import { makeStyles, Theme } from '@material-ui/core';

export const useHeaderLinksStyles = makeStyles<Theme>(theme => ({
  root: {
    display: 'grid',

    [theme.breakpoints.up('xl')]: {
      justifyContent: 'center',
      gridAutoFlow: 'column',
      gap: theme.spacing(0, 4),
    },
  },

  link: {
    transition: 'color 0.2s',
    fontSize: 24,
    justifyContent: 'flex-start',
    minWidth: 0,
    padding:'7px 15px',
    // lineHeight: 'inherit',
    color: '#000',
    cursor: 'pointer',
    background: 'rgba(255, 255, 255, 0.1)',
    backdropFilter: 'blur(24px)',
    borderRadius: '4px',
    fontWeight: 700,
    display:'flex',
    '&:hover': {
        color:'#1C1CFF',
    },
    [theme.breakpoints.up('xs')]: {
      display:'flex'
    },
    [theme.breakpoints.up('sm')]: {
      display:'flex'
    },
    [theme.breakpoints.up('md')]: {
      display:'flex'
    },
    [theme.breakpoints.up('lg')]: {
      display:'flex'
    },
    [theme.breakpoints.up('xl')]: {
      display:'flex'
    },
    [theme.breakpoints.up('HD')]: {
      display:'flex'
    },
    [theme.breakpoints.up('WXGAPlus')]: {
      display:'flex'
    },
  },
  activeLink: {
    cursor: 'default',
    color:'#1C1CFF',
    // background: '#E7DEFE'
  },
  activeLinkRed: {
    cursor: 'default',
    color:'red',
    // background: '#E7DEFE'
  },
}));
